// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__3-NcS","tab":"Tabs_tab__3paFJ","selected":"Tabs_selected__1PwYC"};